import {
  Accordion,
  Card,
  Flex,
  Grid,
  Modal,
  Space,
  Text
} from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/elements/Button';
import FormAddBusinessType from '../../components/forms/FormAddBusinessType';
import FormEditBusinessType from '../../components/forms/FormEditBusinessType';
import IconFailed from '../../components/icons/IconFailed';
import IconSuccess from '../../components/icons/IconSuccess';
import { deleteBusinessType, editBusinessType } from './actions';
import styles from './styles.scoped.css';
import Divider from '../../components/elements/Divider';

function RenderModal({
  variant,
  opened,
  handleCloseModal,
  handleSubmit,
  dataSubmitAddBusinessType,
  dataBusinessType,
  handleReset,
}) {
  const dispatch = useDispatch();

  const handleUpdate = (val) => {
    dispatch(editBusinessType({
      ...dataBusinessType,
      name: val.name,
      kbli: val.codeKbli,
      kbliVersion: val.kbliVersion,
      description: val.description,
      oldName: dataBusinessType.name
    }));
  };

  const handleDelete = () => {
    dispatch(deleteBusinessType(dataBusinessType));
    handleCloseModal();
  };

  const modalVariant = {
    add: {
      title: 'Tambah Jenis Usaha',
      content: <FormAddBusinessType handleReset={handleReset} handleSubmit={handleSubmit} />,
    },
    edit: {
      title: 'Perbarui Jenis Usaha',
      content:
        <FormEditBusinessType
          data={dataBusinessType}
          handleClose={handleCloseModal}
          handleSubmit={handleUpdate} />
    },
    delete: {
      title: 'Hapus Jenis Usaha',
      content: (
        <>
          <Text align="center" mt="md">Apakah kamu yakin untuk menghapus jenis usaha <b>{dataBusinessType.kbli} - {dataBusinessType.name}</b>?</Text>
          <Space h="3dvh" />
          <Flex gap="md">
            <Button fullWidth onClick={handleCloseModal} outlined>
              Batal
            </Button>
            <Button fullWidth onClick={handleDelete} style="danger">
              Ya, Hapus
            </Button>
          </Flex>
        </>
      ),
    },
    reason: {
      title: 'Daftar Jenis Usaha Berhasil Ditambahkan Sebagian',
      size: 'xl',
      content: (
        <Flex direction="column" gap="md">
          <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
            <Flex align="center" direction="row" gap="sm" pl={10}>
              <IconSuccess type={'small'} />
              <Text>
                {dataSubmitAddBusinessType?.data?.successTotal} Jenis Usaha Berhasil Ditambahkan
              </Text>
            </Flex>
          </Card>
          <Accordion radius="md" variant="contained">
            <Accordion.Item value="print">
              <Accordion.Control icon={<IconFailed type={'small'} />} py=".2rem">
                {dataSubmitAddBusinessType?.data?.failedTotal} Jenis Usaha Gagal Ditambahkan
              </Accordion.Control>
              <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
                {dataSubmitAddBusinessType?.data?.failedData?.map((item, index) => (
                  <Grid grow key={index}>
                    <Grid.Col span={4}>
                      <Text fz={14}>{item.name}</Text>
                    </Grid.Col>
                    <Grid.Col span={4}>
                      <Text fz={14} sx={{ color: '#CF212A' }}>{item.reason}</Text>
                    </Grid.Col>
                  </Grid  >
                ))}
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
          <Button fullWidth onClick={handleCloseModal}>
            Tutup
          </Button>
        </Flex>
      )
    }
  };

  return (
    <Modal onClose={handleCloseModal} opened={opened} size={modalVariant[variant]?.size || 'lg'}>
      <div className={styles.container}>
        <Text align="center" component="h3" fw={'normal'} fz={24} my={0}>
          {modalVariant[variant]?.title}
        </Text>
        <Divider />
        <>{modalVariant[variant]?.content}</>
      </div>
    </Modal>
  );
}

export default RenderModal;
RenderModal.propTypes = {
  dataBusinessType: PropTypes.object,
  dataSubmitAddBusinessType: PropTypes.object,
  editName: PropTypes.string,
  errorEditBusinessType: PropTypes.string,
  handleCloseModal: PropTypes.func,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  opened: PropTypes.bool,
  setEditName: PropTypes.string,
  variant: PropTypes.oneOf(['edit', 'add']),
};
